import { AdpImportFileDefinitionResponse } from '@herbjoy/apex-api-models';
import angular, { IQService } from 'angular';
import moment from 'moment';
import { AdpConfigService } from '../../../core/services/data-services/adp-config.service';
import { PayrollService } from '../../../core/services/data-services/payroll.service';
import { UtilityService } from '../../../core/services/utility.service';
import templateUrl from './edit-division-profile-payroll-policy-history-modal.component.html';

export const EditDivisionProfilePayrollPolicyHistoryModal = {
    component: "apexEditDivisionProfilePayrollPolicyHistoryModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
};

export const EditDivisionProfilePayrollPolicyHistoryModalComponent = {
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    templateUrl,
    controller: class EditDivisionProfilePayrollPolicyHistoryModalComponent {
        resolve: any;
        divisionProfile: any;
        divisionRotations: any;
        dismiss: (args: any) => void;
        close: (args: any) => void;
        payrollTypes: any;
        compensationProfiles: any;
        adpImportFileDefinitions: AdpImportFileDefinitionResponse[];
        editForm: any;
        submitting: boolean;
        constructor(private $q: IQService, private adpConfigService: AdpConfigService,
            private divisionService, private employeeService,
            private payrollService: PayrollService,
            private rotationsService,
            private utilityService: UtilityService) {
            'ngInject';
        }

        $onInit() {
            this.divisionProfile = this.resolve.divisionProfile;

            const getPayrollTypes = this.payrollService.retrievePayrollTypes();
            const getDepartments = this.employeeService.retrieveCompensationProfiles();
            this.rotationsService.retrieveDivisionRotations(
                {
                    divisionProfileID: this.divisionProfile.DivisionProfileID
                })
                .then(rotations => {
                    this.divisionRotations = rotations;
                });
            const getAdpImportFileDefinitions = this.adpConfigService.retrieveAdpImportDefinitions();

            const initialDataLoaded = this.$q.all([getPayrollTypes, getDepartments, getAdpImportFileDefinitions])
                .then(([payrollTypes, departments, adpImportFileDefinitions]) => {
                    this.payrollTypes = payrollTypes;
                    this.compensationProfiles = departments;
                    this.divisionProfile.PayrollPolicyHistory.forEach(archive => {
                        archive.PayrollPolicy.PayrollPolicyDepartments.forEach(function (dept) {
                            dept.CompensationProfile = departments.filter(function (compensationProfile) {
                                return dept.CompensationProfileID === compensationProfile.Id;
                            })[0];
                            archive.activeTab = archive.activeTab || dept.CompensationProfile.Id;
                            if (dept.PayrollEntryPolicy) {
                                dept.PayrollEntryPolicy.PayrollType = payrollTypes.filter(function (type) {
                                    return dept.PayrollEntryPolicy.PayrollType &&
                                        type.PayrollTypeID === dept.PayrollEntryPolicy.PayrollType.PayrollTypeID;
                                })[0] || null;
                            }
                        });
                        // Keep a list of departments that haven't been assigned yet.
                        this.updateArchiveCompensationProfiles(archive);
                    });
                    this.adpImportFileDefinitions = adpImportFileDefinitions;
                });

            this.utilityService.showLoadingUntilResolved(initialDataLoaded)
                .catch(ex => {
                    const message = this.utilityService.getExceptionMessage(ex);
                    alert("Initial load failed: " + message);
                    this.dismiss({ $value: message });
                });
        }

        onSave() {
            const request = this.divisionProfile.PayrollPolicyHistory.map(function (archive) {
                return {
                    ActiveStart: archive.ActiveStart,
                    ActiveEnd: archive.ActiveEnd,
                    PayrollPolicy: !archive.PayrollPolicy ? null : {
                        PayrollPolicyID: archive.PayrollPolicy.PayrollPolicyID,
                        AdpImportFileDefinitionID: archive.PayrollPolicy.AdpImportFileDefinitionID,
                        PayrollPolicyDepartments: archive.PayrollPolicy.PayrollPolicyDepartments.map(function (dept) {
                            const policy = dept.PayrollEntryPolicy;
                            return {
                                CompensationProfileID: dept.CompensationProfile.Id,
                                PayrollEntryPolicy: !policy ? null : {
                                    PayrollEntryPolicyID: policy.PayrollEntryPolicyID,
                                    PayrollTypeID: policy.PayrollType ? policy.PayrollType.PayrollTypeID : null,
                                    OvertimeType: policy.OvertimeType,
                                    CommissionPieceCount: policy.CommissionPieceCount,
                                    PayPeriodLength: policy.PayPeriodLength,
                                    UseExtraHours: policy.UseExtraHours
                                }
                            };
                        })
                    }
                }

            });

            if (this.editForm) {
                this.submitting = true;
            }

            const saved = this.divisionService.updateDivisionProfilePayrollPolicyHistory(
                this.divisionProfile.DivisionProfileID, request)
                .then(() => {
                    this.divisionProfile.PayrollPolicyHistory.forEach(function (archive) {
                        archive.PayrollPolicy.PayrollPolicyDepartments.forEach(function (dept) {
                            // Update the compensation profile ID in the object.
                            dept.CompensationProfileID = dept.CompensationProfile.Id;
                        });
                        archive.isNew = false;
                    })
                    if (this.editForm) {
                        this.editForm.$setPristine();
                        this.editForm.$setUntouched();
                    }
                    this.close({ $value: this.divisionProfile.PayrollPolicyHistory });
                });

            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(saved, "Saving failed"))
                // Finally: remove submitting flag.
                .catch(function () { })
                .then(() => {
                    this.submitting = false;
                });
        }

        onAddPayrollPolicyArchive() {
            // Clone the most recent payroll policy and set default archive dates.
            const latestArchive = this.divisionProfile.PayrollPolicyHistory[0];
            const payrollPolicy = {
                PayrollPolicyDepartments: []
            };
            const archive = {
                ActiveStart: null,
                ActiveEnd: null,
                PayrollPolicy: payrollPolicy,
                isNew: true // Indicate that the policy hasn't been saved yet.
            };
            if (latestArchive) {
                if (latestArchive.PayrollPolicy) {
                    payrollPolicy.PayrollPolicyDepartments = latestArchive.PayrollPolicy.PayrollPolicyDepartments
                        .map(department => ({
                            CompensationProfile: department.CompensationProfile,
                            PayrollEntryPolicy: !department.PayrollEntryPolicy ? null : {
                                PayrollType: department.PayrollEntryPolicy.PayrollType,
                                OvertimeType: "NoPremiums",
                                PayPeriodLength: department.PayrollEntryPolicy.PayPeriodLength,
                                CommissionPieceCount: department.PayrollEntryPolicy.CommissionPieceCount,
                                UseExtraHours: department.PayrollEntryPolicy.UseExtraHours
                            }
                        }));
                } else {
                    payrollPolicy.PayrollPolicyDepartments = this.compensationProfiles
                        // TODO: Properly "delete" Dept 750.
                        .filter(compensationProfile => compensationProfile.Id !== 4)
                        .map(function (compensationProfile) {
                            return {
                                CompensationProfile: compensationProfile,
                                PayrollEntryPolicy: null
                            }
                        })
                }
                if (latestArchive.ActiveEnd) {
                    archive.ActiveStart = moment(latestArchive.ActiveEnd).add(1, "day").toDate();
                } else if (!latestArchive.ActiveStart || moment().startOf("day").isAfter(latestArchive.ActiveStart)) {
                    // Set the active start date to today if the previous active start date is not in the future.
                    archive.ActiveStart = moment().startOf("day").toDate();
                    latestArchive.ActiveEnd = moment(archive.ActiveStart).add(-1, "day").toDate();
                }
            }

            this.updateArchiveCompensationProfiles(archive);
            this.divisionProfile.PayrollPolicyHistory.unshift(archive);
        }

        onDeletePayrollPolicyArchive(archive) {
            this.divisionProfile.PayrollPolicyHistory = this.divisionProfile.PayrollPolicyHistory
                .filter(function (_archive) {
                    return _archive !== archive;
                });
        }

        onChangeDates() {
            // Re-sort history in descending order.
            this.divisionProfile.PayrollPolicyHistory.sort(function (a, b) {
                if (a.ActiveStart > b.ActiveStart || !b.ActiveStart) {
                    return -1;
                } else if (a.ActiveStart < b.ActiveStart) {
                    return 1;
                }
                if (b.ActiveEnd || a.ActiveEnd > b.ActiveEnd) {
                    return -1;
                } else if (a.ActiveEnd < b.ActiveEnd) {
                    return 1;
                }
                return 0;
            });

            // Check that the start and end dates don't straddle any rotation dates. ie, active end can only
            // fall on a rotation end date, and vice versa.
            const anyConflicts = this.divisionProfile.PayrollPolicyHistory.reduce((any, archive) => {
                if (any) {
                    return any;
                }
                return this.divisionRotations.reduce(function (any, rotation) {
                    if (any) {
                        return any;
                    }
                    // Archive is invalid if it intersects with the rotation and its active start or
                    // end dates aren't on the boundary start and end dates of that rotation.
                    const archiveIntersectsRotation =
                        archive.ActiveStart && moment(archive.ActiveStart).isBetween(rotation.StartDate, rotation.EndDate, "days", "[]") ||
                        archive.ActiveEnd && moment(archive.ActiveEnd).isBetween(rotation.StartDate, rotation.EndDate, "days", "[]");
                    const archiveDatesOnBoundary = (!archive.ActiveStart || moment(archive.ActiveStart).isSame(rotation.StartDate, "day")) &&
                        (!archive.ActiveEnd || moment(archive.ActiveEnd).isSame(rotation.EndDate, "day"));
                    return archiveIntersectsRotation && !archiveDatesOnBoundary;

                }, false);
            }, false);

            this.editForm.$setValidity("rotationConflict", !anyConflicts);

            // Validate the archive active start and end dates.
            if (!this.editForm) {
                // Nothing to validate.
                return;
            }


            const archivesValid = this.divisionProfile.PayrollPolicyHistory.reduce(function (isValid,
                archive, i, history) {
                if (!isValid) {
                    return isValid;
                }
                if (archive.ActiveEnd && archive.ActiveStart && archive.ActiveEnd < archive.ActiveStart) {
                    // Invalid if the end date is before the start date.
                    return false;
                }
                if (i > 0 && !archive.ActiveEnd || i < history.length - 1 && !archive.ActiveStart) {
                    // Only the earliest entry can have a blank active start, and only the latest can leave a blank active end.
                    return false;
                }
                if (i < history.length - 1) {
                    // Compare the archive with the previous archive in the history (the list is in descending order)
                    const previous = history[i + 1];
                    if (!previous.ActiveEnd) {
                        // Can't follow up a null ending with another archive.
                        return false;
                    }
                    if (previous.ActiveEnd && archive.ActiveStart && moment(archive.ActiveStart).isSameOrBefore(previous.ActiveEnd, 'day')) {
                        // Can't have the next policy start before the previous one ends.
                        // The opposite would also need to be checked if the the history weren't being sorted.
                        return false;
                    }
                }
                return isValid;
            }, true);

            this.editForm.$setValidity("archivesValid", archivesValid);
            this.editForm.$setDirty();
        }

        onAddPayrollEntryPolicy(department) {
            department.PayrollEntryPolicy = department.PayrollEntryPolicy
                ? angular.copy(department.PayrollEntryPolicy)
                : {
                    PayrollType: null,
                    PayPeriodLength: null
                };
        }

        onRemovePayrollEntryPolicy(department) {
            department.PayrollEntryPolicy = null;
        }

        onDeleteDepartment(archive, department) {
            archive.PayrollPolicy.PayrollPolicyDepartments = archive.PayrollPolicy.PayrollPolicyDepartments
                .filter(function (dept) {
                    return dept.CompensationProfile.Id !== department.CompensationProfile.Id;
                })
                .sort(function (a, b) {
                    return a.CompensationProfile.Id < b.CompensationProfile.Id ? -1 : 1;
                });

            this.updateArchiveCompensationProfiles(archive);
        }

        onAddDepartment(archive) {
            if (!archive.newDept) {
                return;
            }

            archive.PayrollPolicy.PayrollPolicyDepartments.push({
                CompensationProfile: archive.newDept
            });

            archive.PayrollPolicy.PayrollPolicyDepartments
                .sort(function (a, b) {
                    return a.CompensationProfile.Id < b.CompensationProfile.Id ? -1 : 1;
                });

            this.updateArchiveCompensationProfiles(archive);
            archive.newDept = null;
        }

        updateArchiveCompensationProfiles(archive) {
            // Update the list of available compensation profiles for the archive.
            archive.compensationProfiles = this.compensationProfiles.filter(function (compensationProfile) {
                return archive.PayrollPolicy.PayrollPolicyDepartments.filter(function (dept) {
                    return dept.CompensationProfile.Id === compensationProfile.Id;
                }).length === 0;
            });
        }
    }
};
